import React, {Component} from "react";
import {Table} from "reactstrap";
import "./AccountTable.css";
import history from "../../history";

class AccountTable extends Component {

    populateTable() {

        return this.props.accounts.map((account, i) => {
            let descrips = this.renderProducts(account.subscriptions);
            return (
                <tr
                    key={i}
                    onClick={() => {
                        history.push("/accounts/" + account.id);
                    }}
                    title={descrips.title}
                >
                    <td className="width-30">{account.name}</td>
                    <td className="width-10">{account.customerId !== "" ? account.customerId : "No Customer ID"}</td>
                    <td className="width-40">{descrips.desc}</td>
                    <td className="width-5">{(account.isInternal ? "I" : "E")}</td>
                    <td className="width-10">{(account.isActive) ? "Active" : "Inactive"}</td>
                </tr>
            );
        });
    }

    sort(field) {
        if (this.props.sortingField === field && this.props.sortingOrder === 1) {
            return "sort-up";
        } else if (
            this.props.sortingField === field &&
            this.props.sortingOrder === -1
        ) {
            return "sort-down";
        } else {
            return "sort";
        }
    }

    renderProducts(subs, i) {
        if (subs && subs.length > 0) {
            const productsList = [];
            for (i = 0; i < subs.length; i++) {
                if (subs[i] === null || subs[i].connectedProducts === undefined || subs[i].connectedProducts.length === 0) {
                    productsList.push("No Products");
                    continue;
                }
                for (let j = 0; j < subs[i].connectedProducts.length; j++) {
                    const productsListElement = subs[i].connectedProducts[j];
                    let pName = productsListElement.productName;
                    if (!productsList.includes(pName)) {
                        productsList.push(pName);
                    }
                }
            }

            let prodDescription = productsList.toString().replace(/,/gi, ", ");
            let short;
            if (prodDescription.length > 100) {
                short = prodDescription.substr(0, 100) + "...";
            } else {
                short = prodDescription;
            }

            return {title: prodDescription, desc: short};
        }
        return {title: "No Products", desc: "No Products"};
    }

    render() {
        return (
            <div className="accounts-table">
                <Table hover className="table table-hover">
                    <thead>
                    <tr>
                        <th className={`width-30 ${this.props.isInFocus && "highlighted"}`}>Name</th>
                        <th className={`width-10 ${this.props.isInFocus && "highlighted"}`}>Customer Id</th>
                        <th className="width-40">Products</th>
                        <th className="width-5">Int</th>
                        <th className="width-10">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.populateTable()}
                    </tbody>
                </Table>
            </div>
        );
    }
}


export default AccountTable;



// WEBPACK FOOTER //
// ./src/accounts/components/AccountTable.js